import styled from 'styled-components';

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 12px 16px;
  border-bottom: 1px solid ${(props) => props.theme.colors.platinum || '#E5E5E5'};
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
  opacity: ${(props) => (props.$disabled ? 0.6 : 1)};
  pointer-events: ${(props) => (props.$disabled ? 'none' : 'auto')};

  &:hover {
    background-color: ${(props) => props.theme.colors.highClearGray || '#F5F5F5'};
  }

  & > .add-menu {
    position: absolute;
    top: 100%;
    right: 0;
    z-index: 1000;
  }
`;

export const ItemLeft = styled.div`
  display: flex;
  flex-direction: row;
  gap: 12px;
  flex: 1;
  align-items: center;
  justify-content: flex-start;
  min-width: 0;
`;

export const ItemIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ItemContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  flex: 1;
  min-width: 0;
`;

export const ItemTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ItemMeta = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  align-items: center;
`;

export const MenuIconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 4px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${(props) => props.theme.colors.platinum || '#E5E5E5'};
  }
`;

